import { render } from "./App.vue?vue&type=template&id=0988616c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=0988616c&lang=css"
script.render = render

export default script